var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MatchContainerWrapped-logo shadow"},[_c('img',{attrs:{"src":_vm.srcLogo,"alt":"logo"}}),_c('div',{staticClass:"MatchContainerWrapped-info"},[_c('p',[_vm._v("VS")]),_c('h3',{staticClass:"text-uppercase text-truncate"},[_vm._v(_vm._s(_vm.match.opponent))]),_c('p',[_vm._v(_vm._s(_vm._f("date")(_vm.match.date)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }